module.exports = __webpack_public_path__ + "img/Pot1.762cab1d.svg";